<i18n>
    {
        "zh": {
            about_artist: "关于艺术家",
            work: "名称",
            client: "客户",
            artist: "艺术家",
            view_more_themes: "查看更多主题",
        },
        "en": {
            about_artist: "About Artist",
            work: "Work",
            client: "Client",
            artist: "Artist",
            view_more_themes: "View more themes",
        },
    }
</i18n>
<script>
import { mapState } from 'vuex';
import ArtistInfo from '../../components/artistInfo.vue';
import BtnBackTop from '../../components/btnBackTop.vue';
import ContactForm from '../../components/contactForm.vue';
import imagesZoom from '../../components/imagesZoom.vue';
import Loading from '../../components/loading.vue';

export default {
    name: "artistImages",
    data() {
        return {
            info: {
                category_id: '',
                category_type: '',
                name: '',
                desc: '',
                introduce: '',
                customer: '',
                honor: '',
            },
            data: [],
            tempData: [],
            list: [
                { height: 0, list: [] },
                { height: 0, list: [] },
                { height: 0, list: [] },
            ],
            listLoadedIndex: 0,
            isShowImgLoading: false,
            page: 1,
            allPage: 1,
            isLoading: false,
            // 主题 - 查看更多主题的链接
            backPath: '',

            isShowArtistInfo: false,
            isShowImagesPanzoom: false,
            checkedIndex: null,
        };
    },
    computed: {
        ...mapState(['talentMenu']),
        type() {
            return this.$route.query.type;
        }
    },
    components: {
        ContactForm,
        ArtistInfo,
        imagesZoom,
        BtnBackTop,
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {
        document.body.style.overflow = 'auto';
    },
    watch: {
        talentMenu: {
            handler: function (value) { 
                if (value.length > 0 && this.info.category_id) { 
                    this.getActiveIndex();
                }
            },
            // immediate: true
        }
    },
    methods: {
        // 初始化图片组，设置瀑布流
        InitList(index = 0) { 
            let item = {...this.tempData[index]};
            // 分析要添加到哪一列
            let heightArr = this.list.map(v => v.height);
            let min = Math.min(...heightArr);
            let listIndex = heightArr.findIndex(v => v == min);
            this.listLoadedIndex = listIndex;
            this.isShowImgLoading = true;
            // image
            let img = new Image();
            img.src = item.thumbnail;
            img.onload = () => {
                // 宽，高，宽高比
                item.width = img.width;
                item.height = img.height;
                item.ratio = img.height / img.width * 100;
                item.realIndex = index + (this.page - 1) * 12;
                append(item, index)
            }
            img.onerror = () => {
                obj.width = 100;
                obj.height = 100;
                obj.ratio = 100;
                item.realIndex = index + (this.page - 1) * 12;
                append(item, index);
            }
            const append = (item, index) => {
                this.list[listIndex].list.push(item);
                this.list[listIndex].height += item.ratio;
                // 递归
                if (index < this.tempData.length - 1) { 
                    this.InitList(++index);
                } else {
                    this.isShowImgLoading = false;
                }
            };
        },
        // 显示大图
        showImage(index) { 
            this.checkedIndex = index;
            this.showPopup('imagesPanzoom');
        },
        // 显示弹窗 - 艺术家信息|大图
        showPopup(name) { 
            document.body.style.overflow = 'hidden';
            switch (name) {
                case 'artistInfo':
                    this.isShowArtistInfo = true;
                    break;
                case 'imagesPanzoom':
                    this.isShowImagesPanzoom = true;
                    break;
                default:
                    break;
            }
        },
        // 关闭弹窗
        closePopup(name) { 
            document.body.style.overflow = 'auto';
            switch (name) {
                case 'artistInfo':
                    this.isShowArtistInfo = false;
                    break;
                case 'imagesPanzoom':
                    this.isShowImagesPanzoom = false;
                    break;
                default:
                    break;
            }
        },
        // 
        getData() {
            if (this.isLoading) { 
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('getTalentImages', {
                id: this.$route.query.id,
                limit: 12,
                page: this.page,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.data = this.data.concat(result.data.list);
                    this.allPage = result.data.last_page;
                    // 临时数据
                    this.tempData = result.data.list;
                    this.InitList();
                    // 
                    this.info = {
                        category_id: result.data.category_id,
                        category_type: result.data.category_type,
                        name: result.data.name,
                        desc: result.data.desc,
                        introduce: result.data.introduce,
                        customer: result.data.customer,
                        honor: result.data.honor,
                    };
                    // 更新菜单索引
                    if (this.talentMenu.length > 0) { 
                        this.getActiveIndex();
                    }

                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 查看更多
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        },
        // 获取对应路由的索引值
        getActiveIndex() { 
            // 父级路由
            let path;
            switch (this.info.category_type) {
                case 3:
                    path = `/talents/artist?id=${this.info.category_id}`
                    break;
                case 5:
                    path = `/talents/theme?id=${this.info.category_id}`
                    this.backPath = path;
                    break;
                default:
                    break;
            }
            // 循环菜单找到对应的索引值
            for (let i = 0; i < this.talentMenu.length; i++) {
                const item = this.talentMenu[i];
                for (let j = 0; j < item.children.length; j++) {
                    const _item = item.children[j];
                    if (_item.link == path) { 
                        // 匹配到二级
                        this.$store.state.TMActiveIndex = [i, j, 0];
                        break;
                    }else if (_item.children.length > 0) {
                        // 二级没有，检查三级
                        const index = _item.children.findIndex(v => v.link == path);
                        if (index != -1) { 
                            this.$store.state.TMActiveIndex = [i, j, index];
                            break;
                        }
                    }
                }
            }
        },
    },
};
</script>

<template>
    <div class="artist_images">
        <div class="wrapper layout_main">
            <!-- 艺术家 -->
            <div class="top flex justify_between align_end" v-if="info.category_type == 3">
                <p class="name">{{ info.name }}</p>
                <p class="about" @click="showPopup('artistInfo')">{{ $t('about_artist') }}</p>
            </div>
            <!-- 主题 -->
            <div class="top flex justify_between align_end" v-if="info.category_type == 5">
                <div>
                    <div class="title only_pc">{{ info.name }}</div>
                    <div class="only_mobile">
                        <div class="title flex justify_between">
                            <p>{{ info.name }}</p>
                            <router-link class="link" :to="backPath">{{ $t('view_more_themes') }}</router-link>
                        </div>
                    </div>
                    <div class="desc">{{ info.desc }}</div>
                </div>
                <router-link class="link only_pc" :to="backPath">{{ $t('view_more_themes') }}</router-link>
            </div>
            <!--  -->
            <div class="list flex justify_between only_pc">
                <div class="item_group flex flex_column" v-for="(item, index) in list" :key="index">
                    <div class="item" v-for="(_item, _index) in item.list" :key="_index" :data-index="_item.realIndex" @click="showImage(_item.realIndex)">
                        <!-- <div class="layout_bg bg" :style="`background-image: url(${_item.thumbnail ? _item.thumbnail : _item.image});padding-bottom: ${_item.ratio}%;`"></div> -->
                        <div class="layout_bg bg" :style="`background-image: url(${_item.thumbnail});padding-bottom: ${_item.ratio}%;`"></div>
                        <div class="text">
                            <p v-if="_item.name">{{ $t('work') }}：{{ _item.name }}</p>
                            <p v-if="_item.artist_name && info.category_type == 5">{{ $t('artist') }}：{{ _item.artist_name }}</p>
                            <p v-if="_item.customer">{{ $t('client') }}：{{ _item.customer }}</p>
                        </div>
                    </div>
                    <Loading v-if="listLoadedIndex == index && isShowImgLoading"/>
                </div>
            </div>
            <div class="list only_mobile">
                <div class="item" v-for="(_item, _index) in data" :key="'m' + _index" :data-index="_index" @click="showImage(_index)">
                    <!-- <div class="layout_bg bg" :style="`background-image: url(${_item.thumbnail ? _item.thumbnail : _item.image});padding-bottom: ${_item.ratio}%;`"></div> -->
                    <img :src="_item.thumbnail ? _item.thumbnail : _item.image" alt=""/>
                    <div class="text">
                        <p v-if="_item.name">{{ $t('work') }}：{{ _item.name }}</p>
                        <p v-if="_item.artist_name && info.category_type == 5">{{ $t('artist') }}：{{ _item.artist_name }}</p>
                        <p v-if="_item.customer">{{ $t('client') }}：{{ _item.customer }}</p>
                    </div>
                </div>
            </div>
            <Loading v-if="isLoading"/>
            <p class="no_more" v-else-if="data.length == 0">{{ $t('noMore') }}</p>
            <p class="no_more" v-else-if="page == allPage">{{ $t('itsOver') }}</p>
            <div class="flex justify_end" v-else-if="isShowImgLoading == false">
                <div class="layout_btn_more" @click="getMore">{{ $t('find_out_more') }}</div>
            </div>
            <!-- 返回顶部按钮 -->
            <BtnBackTop/>
        </div>
        <!-- 表单 -->
        <ContactForm from="人才"/>
        <!-- 关于艺术家弹窗 -->
        <ArtistInfo v-if="info.category_type == 3" :data="info" :show="isShowArtistInfo" @close="closePopup('artistInfo')"/>
        <!-- 查看图片弹窗 -->
        <imagesZoom :show="isShowImagesPanzoom" @close="closePopup('imagesPanzoom')" :data="data" :index="checkedIndex"/>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding-bottom: .7rem;
    position: relative;
    @media only screen and (max-width: 750px) {
        padding-top: .3rem;
    }
}
.top{
    margin-bottom: .4rem;
    .name{
        font-size: .26rem;
    }
    .about,
    .link{
        font-size: .18rem;
        cursor: pointer;
    }
    .link{
        color: #999;
    }
    .title{
        font-size: .24rem;
        margin-bottom: .2rem;
    }
    .desc{
        font-size: .18rem;
        width: 7rem;
    }
    @media only screen and (max-width: 750px) {
        margin-bottom: .3rem;
        .name{
            font-size: .36rem;
        }
        .about,
        .link{
            font-size: .22rem;
        }
        .title{
            font-size: .36rem;
        }
        .desc{
            font-size: .28rem;
        }
    }
}
.list{
    .item_group{
        width: 3.76rem;
        gap: .36rem;
    }
    .item{
        position: relative;
        cursor: pointer;
        overflow: hidden;
        .bg{
            height: 0;
            transition: transform .3s;
        }
        .text{
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            color: #fff;
            padding: .4rem;
            font-size: .18rem;
            background: linear-gradient(to bottom, rgba($color: #000000, $alpha: 0), rgba($color: #000000, $alpha: .8));
            opacity: 0;
            transition: opacity .3s;
        }
        &:hover{
            .bg{
                transform: scale(1.1);
            }
            .text{
                opacity: 1;
            }
        }
        @media only screen and (max-width: 750px) {
            margin-bottom: .3rem;
            img{
                width: 100%;
            }
            .text{
                opacity: 1;
                font-size: .28rem;
            }
        }
    }
}
</style>